'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponders = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getResponders = exports.getResponders = (0, _getIn2.default)(['responders']);


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getResponders.js
// module id = 187
// module chunks = 2 3